export default __webpack_public_path__ + "static/3-c7f07509d9e41f5028c22e29b94970c1.png";